import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../RequestManagerConstants';

class OPTLinkDevicesTask extends AbstractRequestTask {
    constructor(type = null, verificationCode = null) {
      super();
      this.type = type;
      this.verificationCode = verificationCode;
    }

    getMethod() {
      return this.type === 'get' ?  'GET' : 'DELETE';
    }

    getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/user/v1/link-devices/${this.verificationCode}`;
    }

    getParams() {
      const params = super.getParams();    
     // params.code = this.verificationCode;
      delete params.api_version;
      delete params.device_name;
      delete params.device_so;
      delete params.format;
      delete params.user_id;
      delete params.user_token;
      delete params.HKS;
      return Object.assign({}, params);
    }

    getHeaders() {
      return {};
    }

    getShowErrorModal() {
      return ENABLE_MODAL_RETRIES;
    }

    isValid(response) {
      if (response && response.errors) return false;
      return true;
    }
}

export default OPTLinkDevicesTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/opt/OPTLinkDevicesTask.js